import Service from "../../Services";

const SupportGroupVisit = {
  namespaced : true,
  state : {
    form : {
      id : '',
      message : '',
      branch_id : '',
      reply_message : '',
      email : '',
      phone : '',
      organization_name : '',
      is_reply : false,
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
     state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        id : '',
        message : '',
        branch_id : '',
        reply_message : '',
        email : '',
        phone : '',
        organization_name : '',
        is_reply : false,
      }
    }
  },
  actions : {
    getData({commit},{page,search,sort}){
      return Service.CustomerSupportAPI.getGroupVisit(page,search,sort);
    },
    showData({commit},id){
      return Service.CustomerSupportAPI.showGroupVisit(id);
    },
    saveData({commit},{id,data}){
      if(id){
        return Service.CustomerSupportAPI.updateGroupVisit(id,data);
      }else{
        return Service.CustomerSupportAPI.createGroupVisit(data);
      }
    },
    deleteData({commit},id){
      return Service.CustomerSupportAPI.deleteGroupVisit(id);
    },
    setFormData({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default SupportGroupVisit
